<template>
  <div class="notes">
    <div v-html="character.notes" />
  </div>
</template>

<script>
import { defineComponent, inject } from 'vue'

export default defineComponent({
  setup () {
    const character = inject('character')
    return {
      character
    }
  }
})
</script>

<style lang="sass" scoped>
.notes
  width: 100%

.notes > div
  font-family: 'Merriweather', serif
  font-size: 90%
  width: 100%
  white-space: pre-line

.notes > div:empty::after
  content: "— You haven't written any notes —"
  display: block
  color: #7a7a7a
  text-align: center
</style>
